import { z } from 'zod';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var ChangeDirection = {
  POSITIVE: "positive",
  NEGATIVE: "negative",
  NEUTRAL: "neutral"
};
var CHANGE_DIRECTION_VALUES = Object.values(ChangeDirection);
function toChangeDirection(change) {
  if (change > 0) return ChangeDirection.POSITIVE;
  if (change < 0) return ChangeDirection.NEGATIVE;
  return ChangeDirection.NEUTRAL;
}
__name(toChangeDirection, "toChangeDirection");
var SERVICE_REGISTRY = [
  {
    id: "office365"
  },
  {
    id: "google-workspace"
  },
  {
    id: "sharepoint"
  }
];
var CONNECTED_SERVICE_VALUES = SERVICE_REGISTRY.map((s) => s.id);
if (CONNECTED_SERVICE_VALUES.length === 0) {
  throw new Error("SERVICE_REGISTRY must have at least one entry");
}
var ConnectedServiceSchema = z.enum(CONNECTED_SERVICE_VALUES);
var ConnectedServicesSchema = z.array(ConnectedServiceSchema);
var ALL_SERVICES = "all";
var SERVICE_FILTER_VALUES = [
  ALL_SERVICES,
  ...CONNECTED_SERVICE_VALUES
];
var SERVICE_FILTER_DEFAULT = ALL_SERVICES;
var DAYS_FILTER_VALUES = [
  1,
  7,
  14,
  30,
  60,
  90,
  180
];
var DAYS_FILTER_DEFAULT = 7;
var TIME_FRAME_PARAMS = DAYS_FILTER_VALUES.map(String);
var CONNECTED_SERVICE_IDS = CONNECTED_SERVICE_VALUES;
function isTimeFrameParam(value) {
  return value != null && TIME_FRAME_PARAMS.includes(value);
}
__name(isTimeFrameParam, "isTimeFrameParam");
function isConnectedService(value) {
  return value != null && CONNECTED_SERVICE_IDS.includes(value);
}
__name(isConnectedService, "isConnectedService");
function effectiveService(stored, connected) {
  if (stored === void 0 || stored === ALL_SERVICES) return stored;
  return isConnectedService(stored) && connected.includes(stored) ? stored : ALL_SERVICES;
}
__name(effectiveService, "effectiveService");
function isServiceOffered(value, connected) {
  return !isConnectedService(value) || connected.includes(value);
}
__name(isServiceOffered, "isServiceOffered");
var DAYS_FILTER_OPTIONS = [
  {
    value: 1,
    label: "Last Day"
  },
  {
    value: 7,
    label: "Last 7 Days"
  },
  {
    value: 14,
    label: "Last 14 Days"
  },
  {
    value: 30,
    label: "Last 30 Days"
  },
  {
    value: 60,
    label: "Last 60 Days"
  },
  {
    value: 90,
    label: "Last 90 Days"
  },
  {
    value: 180,
    label: "Last 180 Days"
  }
];
var SIZE_UNITS = [
  "GB",
  "TB",
  "PB"
];
var BYTES_PER_GB = 1e9;
function bytesToSize(bytes) {
  const gb = bytes / BYTES_PER_GB;
  if (gb >= 1e6) return {
    sizeValue: Math.round(gb / 1e6 * 100) / 100,
    sizeUnit: "PB"
  };
  if (gb >= 1e3) return {
    sizeValue: Math.round(gb / 1e3 * 100) / 100,
    sizeUnit: "TB"
  };
  return {
    sizeValue: Math.round(gb * 10) / 10,
    sizeUnit: "GB"
  };
}
__name(bytesToSize, "bytesToSize");
var TOP_DATA_TAB_IDS = [
  "all",
  "public",
  "internal",
  "confidential",
  "restricted",
  "highly-confidential"
];
var SENSITIVITY_TIERS = [
  {
    id: "highly-confidential",
    label: "Highly Confidential",
    level: "highly confidential",
    fillColor: "#F47600",
    foregroundColor: "#FFFFFF"
  },
  {
    id: "restricted",
    label: "Restricted",
    level: "restricted",
    fillColor: "#FF9700",
    foregroundColor: "#FFFFFF"
  },
  {
    id: "confidential",
    label: "Confidential",
    level: "confidential",
    fillColor: "#FFBB60",
    foregroundColor: "#1B1B1B"
  },
  {
    id: "internal",
    label: "Internal",
    level: "internal",
    fillColor: "#FFDBA9",
    foregroundColor: "#1B1B1B"
  },
  {
    id: "public",
    label: "Public",
    level: "public",
    fillColor: "#FFEACE",
    foregroundColor: "#1B1B1B"
  }
];
var SENSITIVITY_EXTERNAL_COLOR = "#F44236";
var SENSITIVITY_UNCLASSIFIED_COLOR = "#8D8D8D";
var SENSITIVITY_UNCLASSIFIED_ID = "unclassified";
var SENSITIVITY_UNCLASSIFIED_LABEL = "Unclassified";
var SENSITIVITY_UNCLASSIFIED_LEVEL = "unclassified";
function sensitivityLevelFor(id) {
  if (id === SENSITIVITY_UNCLASSIFIED_ID) return SENSITIVITY_UNCLASSIFIED_LEVEL;
  return SENSITIVITY_TIERS.find((tier) => tier.id === id)?.level;
}
__name(sensitivityLevelFor, "sensitivityLevelFor");
var SENSITIVITY_RANK_BY_ID = new Map([
  ...SENSITIVITY_TIERS.map((tier, i) => [
    tier.id,
    i
  ]),
  [
    SENSITIVITY_UNCLASSIFIED_ID,
    SENSITIVITY_TIERS.length
  ]
]);
function sensitivityRank(id) {
  return SENSITIVITY_RANK_BY_ID.get(id) ?? Number.POSITIVE_INFINITY;
}
__name(sensitivityRank, "sensitivityRank");
function sensitivityLevelsFor(ids) {
  return ids.map((id) => {
    const tier = SENSITIVITY_TIERS.find((candidate) => candidate.id === id);
    if (!tier) throw new Error(`Unknown sensitivity tier: ${id}`);
    return tier.level;
  });
}
__name(sensitivityLevelsFor, "sensitivityLevelsFor");

export { ALL_SERVICES, CHANGE_DIRECTION_VALUES, CONNECTED_SERVICE_VALUES, ChangeDirection, ConnectedServiceSchema, ConnectedServicesSchema, DAYS_FILTER_DEFAULT, DAYS_FILTER_OPTIONS, DAYS_FILTER_VALUES, SENSITIVITY_EXTERNAL_COLOR, SENSITIVITY_TIERS, SENSITIVITY_UNCLASSIFIED_COLOR, SENSITIVITY_UNCLASSIFIED_ID, SENSITIVITY_UNCLASSIFIED_LABEL, SENSITIVITY_UNCLASSIFIED_LEVEL, SERVICE_FILTER_DEFAULT, SERVICE_FILTER_VALUES, SERVICE_REGISTRY, SIZE_UNITS, TOP_DATA_TAB_IDS, bytesToSize, effectiveService, isConnectedService, isServiceOffered, isTimeFrameParam, sensitivityLevelFor, sensitivityLevelsFor, sensitivityRank, toChangeDirection };
//# sourceMappingURL=dashboard-widgets.js.map
//# sourceMappingURL=dashboard-widgets.js.map